module.exports = __webpack_public_path__ + "static/media/3.faa234b5.jpg";